/** @format */
import {GraphStat} from '../../models/common';
import {ALL_CHART_IDS} from '../../constants/allChartIds';
import {PartialGraphStatList} from './types';

const mergeCollections = (collections: PartialGraphStatList[], allDates: string[]): GraphStat[] => {
  // Важно: не должно быть пропущенных дат, поэтому вычисляем их из периода allDates
  const result: GraphStat[] = [];

  const baseTemplate: Partial<GraphStat> = {};
  // Все undefined значения должны быть 0
  ALL_CHART_IDS.forEach(chartId => {
    baseTemplate[chartId] = 0;
  });

  allDates.forEach(date => {
    const merged = collections.reduce<Partial<GraphStat>>(
      (acc, collection) => ({
        ...acc,
        ...collection[date],
      }),
      {
        date,
        ...baseTemplate,
      },
    );

    result.push(merged as GraphStat);
  });

  return result;
};

export {mergeCollections};
